const retryCountEvent = ({ count = 1 }) => {
  const event = new Event('itemInserted');
  event.value = count;
  event.key = 'retrying-registration';
  document.dispatchEvent(event);
};

export { retryCountEvent };
